<div class="col">
  <div class="card" (click)="onClick()">
    <img [src]="cardImg" class="card-img-top" alt="...">
    <div class="card-icon">
      <fa-icon [icon]="cardIcon"></fa-icon>
    </div>
    <div class="card-body">
      <h5 class="card-title">{{cardTitle}}</h5>
      <p class="card-text">{{cardDescription}}</p>
    </div>
  </div>
</div>
